import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const IdCard = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="id card icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2H34C36.2091 2 38 3.79086 38 6V42C38 44.2091 36.2091 46 34 46H14C11.7909 46 10 44.2091 10 42V6C10 3.79086 11.7909 2 14 2ZM8 6C8 2.68629 10.6863 0 14 0H34C37.3137 0 40 2.68629 40 6V42C40 45.3137 37.3137 48 34 48H14C10.6863 48 8 45.3137 8 42V6ZM14 38V40H34V38H14ZM34 32V34H14V32H34ZM14 26V28H34V26H14ZM34 20V22H14V20H34ZM27 16H34V14H27V16ZM34 10H27V8H34V10ZM22 12C22 13.6569 20.6569 15 19 15C17.3431 15 16 13.6569 16 12C16 10.3431 17.3431 9 19 9C20.6569 9 22 10.3431 22 12ZM24 12C24 14.7614 21.7614 17 19 17C16.2386 17 14 14.7614 14 12C14 9.23858 16.2386 7 19 7C21.7614 7 24 9.23858 24 12Z"
    />
  </svg>
)
